import { BLAuth } from "@brandlive/client-auth";

export default new BLAuth(process.env.REACT_APP_API_HOST as string, process.env.REACT_APP_LOGIN_HOST as string);